import createSvgIcon from "./utils/create_icon"

const ChevronRight = createSvgIcon(<path clipRule="evenodd" d="M10.293 15.707a1 1 0 0 1 0-1.414L12.586 12l-2.293-2.293a1 1 0 1 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414 0z" fill="currentColor" fillRule="evenodd" />, "ChevronRight")
export default ChevronRight
